import React from 'react';
import { Button, ButtonProps, Tooltip } from '@material-ui/core';
import { InsertComment } from '@material-ui/icons';

export function ButtonInsertNote({ ...rest }: ButtonProps) {
  return (
    <Tooltip title='Insert a Note'>
      <Button {...rest}>
        <InsertComment />
      </Button>
    </Tooltip>
  );
}
